import React, { useCallback, useState } from 'react';

import { Box, cx } from 'ui';

import { usePlatformShare } from '../../../hooks/usePlatformShare';
import { TicketShareModal } from '../../organisms';
import classes from './EventTicket.module.css';
import EventTicketHeader from './EventTicketHeader';
import EventTicketInfo from './EventTicketInfo';
import type { EventTicketInfo as EventTicketInfoType } from './pdf/eventTicketsPdf.types';

export interface EventTicketProps
  extends EventTicketInfoType,
    Omit<React.ComponentProps<'button'>, 'title'> {
  eventThumbnail?: string;
  subtitle?: string;
  eventStartDate: string;
  venueName?: string;
  addressLineOne?: string;
  addressLineTwo?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  totalTickets?: number;
  ticketId: string;
  ticketName: string;
  ticketNumber?: number;
  isExpired: boolean;
  isDeleted?: boolean;
  onAddTicketToWallet?: () => void;
}

const EventTicket = ({
  className,
  eventThumbnail,
  title,
  subtitle,
  eventStartDate,
  venueName,
  addressLineOne,
  addressLineTwo,
  city,
  state,
  zipCode,
  totalTickets,
  ticketId,
  ticketName,
  ticketNumber,
  isExpired = false,
  isUsed = false,
  isDeleted = false,
  onAddTicketToWallet,
  ticketQrCodeUrl,

  ticketUrl,
}: EventTicketProps) => {
  const [isTicketShareModalOpen, setIsTicketShareModalOpen] = useState(false);
  const { platformShare } = usePlatformShare();

  const shareTicket = useCallback(
    (ticketUrl: string) => {
      void platformShare({ share_options: { url: ticketUrl } }, () =>
        setIsTicketShareModalOpen(true)
      );
    },
    [platformShare]
  );

  return (
    <>
      <Box className={cx(classes.EventTicket, className)} p={0}>
        <EventTicketHeader
          eventThumbnail={eventThumbnail}
          totalTickets={totalTickets}
          ticketNumber={ticketNumber}
          isExpired={isExpired}
          isUsed={isUsed}
          isDeleted={isDeleted}
          onShareTicket={() => shareTicket(ticketUrl)}
        />
        <EventTicketInfo
          title={title}
          subtitle={subtitle}
          eventStartDate={eventStartDate}
          venueName={venueName}
          addressLineOne={addressLineOne}
          addressLineTwo={addressLineTwo}
          city={city}
          state={state}
          zipCode={zipCode}
          ticketName={ticketName}
          ticketId={ticketId}
          ticketUrl={ticketUrl}
          isUsed={isUsed}
          isExpired={isExpired}
          isDeleted={isDeleted}
          onAddTicketToWallet={onAddTicketToWallet}
          ticketQrCodeUrl={ticketQrCodeUrl}
        />
      </Box>
      <TicketShareModal
        opened={isTicketShareModalOpen}
        onClose={() => setIsTicketShareModalOpen(false)}
        eventName={`${title} ${subtitle ? `- ${subtitle}` : ''}`}
        dateTime={eventStartDate}
        ticketName={ticketName}
        ticketUrl={ticketUrl ?? ''}
      />
    </>
  );
};

export { EventTicket };
